export default __webpack_public_path__ + "static/media/ItalyFlag.964b081b.png";